import { isString } from 'fitify-types/src/type-guards/common'
import { logEvent } from 'fitify-ui-onboarding/src/utils/analytics'
import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useEffect, useRef, useState } from 'react'

import { CookieBotGlobalStyle } from './CookieBotStyles.Styled'

export const CookieBotStyles = () => {
  const growthBook = useGrowthBook()
  const hasBeenShown = useRef(false)
  const [bannerStyle, setBannerStyle] = useState('black_with_logo')

  useEffect(() => {
    const handleCookiebotDialogDisplay = () => {
      queueMicrotask(() => {
        const isBottomBannerDisplayed = document.querySelector(
          '#CybotCookiebotDialog[data-template="bottom"]'
        )
        if (!hasBeenShown.current && isBottomBannerDisplayed) {
          hasBeenShown.current = true
          logEvent('cookie_banner_shown', { banner_style: bannerStyle })

          const cookieBannerStyle = growthBook.evalFeature(
            'cookie_banner_style'
          )?.value
          if (isString(cookieBannerStyle)) {
            setBannerStyle(cookieBannerStyle)
          }
        }
      })
    }
    window.addEventListener(
      'CookiebotOnDialogDisplay',
      handleCookiebotDialogDisplay
    )

    return () => {
      window.removeEventListener(
        'CookiebotOnDialogDisplay',
        handleCookiebotDialogDisplay
      )
    }
  }, [bannerStyle, growthBook])

  return <CookieBotGlobalStyle $bannerStyle={bannerStyle} />
}
